export const formatReportType = (reportType: unknown): string => {
  const raw = typeof reportType === 'string' ? reportType.trim() : '';
  if (!raw) return 'N/A';

  const normalized = raw.toLowerCase();
  if (normalized === 'ticket_balance') return 'Receipt Audit';
  if (normalized === 'vending_sales') return 'Vending Sales';
  if (normalized === 'vending_inventory') return 'Vending Inventory';
  if (normalized === 'vending_shift_report') return 'Vending Shift Report';
  if (normalized === 'sciq_ticket_audit') return 'Sciq Ticket Audit';

  return normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
